<template>

<div class="context" :class="{'is-inline': isInline}" v-bind:style="{'marginLeft': (isInline && window.menuIndentContent !== '320px') ? window.menuIndentContent : 0}">

    <i class="fa-brands fa-patreon context-avatar" />

    <div class="context-info" v-if="!isInline || window.is.mobile">
        <div class="context-name">Patreon</div>
        <div class="context-username">Support the website</div>
    </div>

</div>

</template>

<script>

export default {

    props: ['isInline'],

    computed: {

        patreon: function() {

            return this.$store.getters['context'].patreon

        },

        boosted: function() {

            return this.$store.getters['context'].boosted

        },

        subdomain: function() {

            return this.$store.getters['context'].subdomain

        },

		registered: function() {

			return this.$filter('formatDate', this.$store.getters['context'].date.registered, 'YYYY')

		},

		username: function() {

			return this.$store.getters['context'].name 

		},

		realname: function() {

			return this.$store.getters['context'].fullname || this.$store.getters['context'].name 

		},

		country: function() {

			return this.$store.getters['context'].country

		},

        lastSync: function() {
        
            return this.$store.getters['context'].date.sync

        },

		countryName: function() {

			return this.$CONSTANTS.COUNTRY[this.$store.getters['context'].country]

		}

	},

    methods: {

        onMenuOpenClick: function() {
        
            this.$pubsub.$emit('menu.open')
        
        },

        onMenuCloseClick: function() {
        
            this.$pubsub.$emit('menu.close')
        
        },
    
        onSyncClick: function() {
        
            this.$pubsub.$emit('open.modal', 'appSyncs')
        
        }
    
    }

}

</script>

<style scoped>

.context {
    padding: 0px 20px;
    height: 88px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
}

.is-mobile .context {
    padding: 20px 20px;
    height: auto;
}

.is-smaller .context.is-inline {
    position: fixed;
    height: 64px;
    top: 64px;
    left: 0px;
    width: 142px;
    padding: 0px 20px 0px 14px;
    z-index: 100;
	transition: margin-left 100ms linear;
}

.is-mobile .context.is-inline {
    position: fixed;
    height: 48px;
    top: 48px;
    left: 0px;
    padding: 0px 10px;
    width: 100%;
    z-index: 100;
}

.is-minimised .context {
    padding: 0px;
}

.is-minimised .context:after {
    display: none;
}

.context-avatar {
    width: 48px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    font-size: 20px;
    background-size: cover;
    background-color: #082534;
    background-position: 50% 50%;
    border-radius: 50%;
    flex-shrink: 0;
    background-size: auto 32px;
    background-repeat: no-repeat;
}

.is-smaller .context.is-inline .context-avatar {
    width: 40px;
    height: 40px;
    margin: 0px 4px 0px 14px;
}

.is-mobile .context-avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    margin: 0px 4px 0px 0px;
}

.is-mobile .context.is-inline .context-avatar {
    width: 32px;
    height: 32px;
    margin: 0px 4px 0px 0px;
}

.is-minimised .context-avatar {
    border-radius: 0px;
}

.context-action {
    width: 40px;
    margin-left: 5px;
    flex-shrink: 0;
}

.context-action >>> .button-icon {
    margin-left: 0px;
}

.is-mobile .context-action {
    width: 32px;
    min-width: 32px;
    height: 32px;
}

.context-info {
    margin-left: 10px;
    flex-grow: 1;
}

.is-mobile .context-info {
    margin-left: 6px;
}

.is-minimised .context-info {
    display: none;
}

.context-name {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 1px;
    font-family: 'Barlow', sans-serif;
    color: #fff;
}

.is-mobile .context-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    letter-spacing: 0px;
}

.context-username {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1px;
    margin-top: 4px;
    color: #fff;
    opacity: 0.5;
}

.is-smaller .context-username {
    margin-top: 4px;
    font-size: 14px;
}

.is-mobile .context-username {
    margin-top: 2px;
    font-size: 12px;
}

.context-updated {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 1px;
    margin-top: 4px;
    color: #fff;
    opacity: 0.5;
}

.context-updated span {
    border-bottom: 1px dashed transparent;
}

.context-updated:hover {
    opacity: 0.8;
    cursor: pointer;
}

.context-updated:hover span {
    border-bottom: 1px dashed #fff;
}

.context-flag {
    width: 16px;
    height: 16px;
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    right: -3px;
    bottom: -3px;
}

.is-minimised .context-flag {
    display: none;
}

.context-icons-wrapper {
    flex-shrink: 0;
    height: 24px;
    width: 48px;
}

.context-icons {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    top: 0px;
}

.context-boost {
    border-radius: 50%;
    width: 24px;
    font-size: 14px;
    position: relative;
    height: 24px;
    text-align: center;
    line-height: 24px;
    margin-left: 2px;
    z-index: 10;
    transition: all 100ms ease-in-out;
}

.context-boost.is-dark {
    color: #fff;
    background-color: #4881bb;
}

.context-boost.is-orange {
    color: #082534;
    background-color: #ffc563;
}

.context-boost.is-green {
    color: #fff;
    background-color: #48bb6d;
}

.context-boost:nth-child(2) {
    z-index: 9;
    margin-left: -12px;
}

.context-boost:nth-child(3) {
    z-index: 8;
    margin-left: -12px;
}

.context-icons:hover .context-boost:nth-child(2),
.context-icons:hover .context-boost:nth-child(3) {
    margin-left: 2px;
}

</style>
